export const FileBaseUrl = "https://cdn.psiapp.com.br/";
